<template>
  <!-- 导航栏 -->
  <!-- eslint-disable -->
  <div class="head" @mouseleave="rout(99)">
    <div class="heade">
      <div class="heades">
        <div class="header">
          <div class="headerLeft">
            <!-- <img v-show="srcs == 1" src="@/assets/img/home/logo (1).png" alt=""> -->
            <img src="@/assets/tu72.png" alt="" />
          </div>
          <div class="headerRight">
            <div class="headerRights" @click="nexts(0)">免费试用</div>
            <div class="clickicon" @click="showPopup">
              <img src="@/assets/zu2.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="show" class="showright" position="right">
      <div class="popupstyle">
        <div class="popuptop">
          <div class="logo" />
          <div class="close" @click="unshowPopup" />
        </div>
        <div @click="rout(0)">首页</div>
        <!-- <div @click="ifshowwxxt">
          产品与服务
          <span v-if="isShow" @click="closet" class="top_point"></span>
          <span v-else class="bottom_point"></span>
        </div> -->
        <!-- <div class="wx" v-if="ifshowwx" @click="nexts(1)">网校系统</div> -->
        <!-- <div class="wx" v-if="ifshowwx" @click="goNext('/dgnstyle1')">系统</div> -->
        <div @click="goNext('/zcfw1')">服务支持</div>
        <div @click="goNext('/sys1')">垂直管理系统</div>
        <div @click="goNext('/dgnstyle1')">多功能学习平台</div>

        <div @click="rout(2)">课程共建</div>
        <div @click="rout(3)">合作招商</div>
        <!-- <div @click="ifshowgywm"> -->
        <div @click="nextsa(0)">
          关于我们
          <!-- <span v-if="isShow1" class="top_point"></span>
          <span v-else class="bottom_point"></span> -->
        </div>
        <!-- <div v-if="ifshowgy" class="a">
          <span @click="nextsa(0)">公司简介</span>
          <span @click="nextsa(1)">加入我们</span>
          <span @click="nextsa(2)">新闻动态</span>
        </div> -->
        <div class="btn-try" @click="nexts(0)">免费试用</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  /* eslint-disable */
  data () {
    return {
      a: true, // 产品与服务 展开收起三角
      as: '', // 产品与服务 选中颜色
      b: true, // 关于我们 展开收起三角
      bs: '', // 关于我们 选中颜色
      c: 99,

      srcs: 1,
      colors: false,
      show: false,
      ifshowwx: false,
      ifshowgy: false,
      isShow: true,
      isShow1: true,
    }
  },
  created () {
    this.as = this.$route.query.inde
    this.bs = this.$route.query.inde
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    closet () {
      this.ifshowwx = false
      this.isShow = true
    },
    unshowPopup () {
      this.show = false
    },
    ifshowwxxt () {
      if (this.ifshowwx == false) {
        this.ifshowwx = true
        this.isShow = false
      } else {
        this.ifshowwx = false
        this.isShow = true
      }
    },
    ifunshowwxxt () {
      this.ifshowwx = false
    },
    ifshowgywm () {
      if (this.ifshowgy == false) {
        this.ifshowgy = true
        this.isShow1 = false
      } else {
        this.ifshowgy = false
        this.isShow1 = true
      }
    },
    ifunshowgywm () {
      this.ifshowgy = false
    },

    // 导航栏页面跳转
    showPopup () {
      this.show = true
    },
    rout (index) {
      this.c = index
      if (index === 0) {
        this.$router.push({ path: '/' })
      } else if (index === 1) {
        this.a = !this.a
        this.c = 1
        // this.as=0
        if (this.b === false) {
          this.b = true
          // this.bs=0
        }
      } else if (index === 2) {
        this.$router.push({ path: '/curriculum1' })
      } else if (index === 3) {
        this.$router.push({ path: '/cooperation1' })
      } else if (index === 4) {
        this.b = !this.b
        this.c = 4
        // this.bs=0
        if (this.a === false) {
          this.a = true
          // this.as=0
        }
      } else if (index === 5) {
        this.$router.push({ path: '/productSystems1', query: { inde: index } })
      } else if (index === 99) {
        this.a = true
        this.b = true
        this.c = 99
      }
    },
    // 产品与服务 展开选中颜色
    nexts (index) {
      this.as = index
      if (index === 1) {
        // 网校系统
        console.log(1)
        this.$router.push({ path: '/productSystem1', query: { inde: index } })
      } else {
        this.$router.push({ path: '/mfsy1' })
      }
    },
    // 关于我们 展开选中颜色
    nextsa (index) {
      this.bs = index
      if (index === 0) {
        // 加入我们
        this.$router.push({ path: '/aboutIntroduce1', query: { inde: index } })
      } else if (index === 1) {
        // 加入我们
        this.$router.push({ path: '/aboutJoin1', query: { inde: index } })
      } else if (index === 2) {
        this.$router.push({ path: '/aboutNew1', query: { inde: index } })
      }
    },
    // 页面移动导航栏改变颜色
  },
}
</script>
<style lang="less" scoped>
// 导航栏
.head {
  width: 750px;
  height: 128px;
  // background: rgba(0, 0, 0, 0.2);
  // background: rgba(0, 0, 0, 0.2) none repeat scroll 0 0 !important;
  position: fixed;
  background-color: #ffffff;
  top: 0;
  left: 0;
  z-index: 99;
  // color: #ffffff;
  // 缩宽
  .heade {
    // width: 100%;
    height: 128px;
    position: relative;
    .heades {
      // width: 100%;
      height: auto;
      // box-shadow: 0px 3px 7px rgba(153, 153, 153, 0.2);
      .header {
        box-sizing: border-box;
        // width: auto;
        height: 128px;
        padding-top: 34px;
        // margin: 0 360px;
        // margin-left: 32px;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        // 左侧logo
        .headerLeft {
          width: 200px;
          height: 60px;
          padding-left: 32px;
          float: left;
          img {
            width: 100%;
            height: 100%;
          }
        }

        // 右侧导航栏内容
        .headerRight {
          // width: auto;
          height: 100%;
          float: right;
          .headerRights {
            float: left;
            width: 180px;
            height: 60px;
            border-radius: 30px;
            background: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            // margin-left: 40px;
            margin-right: 20px;
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #2068ff;
            border: 1px solid #2068ff;
            cursor: pointer;
          }
          .clickicon {
            width: 60px;
            height: 60px;
            float: left;
            margin-right: 32px;
            display: flex;
            align-items: center;
            // margin-top: 6px;
            img {
              width: 48px;
              height: 48px;
              background-size: cover;
            }
          }
        }
        // display: flex;
        // justify-content: flex-end;
        // align-items: center;
        //   // 内容

        //   .headerRighta {
        //     width: auto;
        //     height: 100%;
        //     display: flex;
        //     justify-content: flex-start;
        //     align-items: center;
        //     flex-direction: column;
        //     cursor: pointer;
        //     div{
        //       width: auto;
        //       height: 21px;
        //       margin-top: 25px;
        //       display: flex;
        //       justify-content: center;
        //       // align-items: center;
        //       font-size: 16px;
        //       // color: #FFFFFF;
        //       font-family: Microsoft YaHei;
        //       font-weight: 400;
        //       margin-left: 40px;
        //       img {
        //         width: 8px;
        //         height: 4.8px;
        //         margin-left: 4px;
        //         margin-top: 10px;
        //       }
        //     }
        //     div:hover{
        //       color: #2068FF;
        //     }
        //     .headerRightaspan{
        //       color: #2068FF;
        //     }
        //     img {
        //       width: 11px;
        //       height: 6px;
        //       margin-top: 15px;
        //       margin-left: 40px;
        //     }
        //   }
        //   // 右侧导航栏按钮免费试用
        //   // .headerRights {
        //   //   width: 180px;
        //   //   height: 60px;
        //   //   border-radius: 30px;
        //   //   background: #ffffff;
        //   //   display: flex;
        //   //   justify-content: center;
        //   //   align-items: center;
        //   //   // margin-left: 40px;
        //   //   margin-right: 100px;
        //   //   font-size: 24px;
        //   //   font-family: Microsoft YaHei;
        //   //   font-weight: 400;
        //   //   // color: #2068ff;
        //   //   border: 1px solid #2068ff;
        //   //   cursor: pointer;
        //   // }
        // }
      }
    }
    // .ponHead{
    //   width: 140px;
    //   height: 140px;
    //   position: absolute;
    //   top: 67px;
    //   right: 480px;
    //   background: #FFFFFF;
    //   opacity: 1;
    //   border-radius: 0px 0px 4px 4px;
    //   div{
    //     width: 100%;
    //     height: 100%;
    //     display: flex;
    //     flex-direction: column;
    //     justify-content: flex-start;
    //     align-items: center;
    //     span{
    //       width: auto;
    //       height: 19px;
    //       margin-top: 20px;
    //       font-size: 14px;
    //       font-family: Microsoft YaHei;
    //       font-weight: 400;
    //       color: #222222;
    //       opacity: 1;
    //       cursor: pointer;
    //     }
    //     .pspana{
    //       color: #2068FF;
    //     }
    //   }
    // }
    // .ponHeads{
    //   width: 140px;
    //   // height: 140px;
    //   height: auto;
    //   position: absolute;
    //   top: 67px;
    //   right: 850px;
    //   background: #FFFFFF;
    //   opacity: 1;
    //   border-radius: 0px 0px 4px 4px;
    //   div{
    //     width: 100%;
    //     height: 100%;
    //     display: flex;
    //     flex-direction: column;
    //     justify-content: flex-start;
    //     align-items: center;
    //     span{
    //       width: auto;
    //       height: 19px;
    //       margin-top: 20px;
    //       margin-bottom: 20px;
    //       font-size: 14px;
    //       font-family: Microsoft YaHei;
    //       font-weight: 400;
    //       color: #222222;
    //       opacity: 1;
    //       cursor: pointer;
    //     }
    //     .pspana{
    //       color: #2068FF;
    //     }
    //   }
    // }
  }
  .showright {
    width: 600px;
    height: 100%;
    .popupstyle {
      display: flex;
      flex-direction: column;
      justify-content: top;
      font-size: 30px;
      margin-left: 30px;

      div {
        height: 102px;
        line-height: 102px;
        border-bottom: 1px solid #eeeeee;
        font-weight: 600;
        font-size: 30px;
        .top_point {
          display: block;
          float: right;
          width: 48px;
          height: 48px;
          background-image: url("~@/assets/zu989.png");
          background-size: cover;
          margin-top: 30px;
          margin-right: 30px;
        }
        .bottom_point {
          display: block;
          float: right;
          width: 48px;
          height: 48px;
          background-image: url("~@/assets/zu989 (1).png");
          background-size: cover;
          margin-top: 30px;
          margin-right: 30px;
        }
      }
      .wx {
        font-size: 28px;
        color: #242526;
        font-weight: 400;
      }
      .a {
        width: 600px;
        height: 182px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        span {
          display: flex;
          // flex-direction: column;
          font-weight: 400;
          font-size: 28px;
          width: 50%;
        }
      }
      .popuptop {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .logo {
          width: 150px;
          height: 50px;
          background-image: url("~@/assets/tu72.png");
          background-size: cover;
        }
        .close {
          width: 48px;
          height: 48px;
          background-image: url("~@/assets/zu992.png");
          background-size: cover;
          margin-right: 30px;
        }
      }
      .btn-try {
        width: 540px;
        height: 80px;
        background-color: #2068ff;
        border-radius: 40px;
        margin: auto;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
        color: #ffffff;
      }
    }
  }
}
</style>
